var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "decommissionVehicleModal",
        size: "md",
        "content-class": "sub-menu-bg-blue-transparent dcv-modal",
        title: "Decommission Vehicle",
        "hide-footer": "",
        "no-fade": "",
        "header-close-variant": "light",
      },
    },
    [
      _vm.vehicle
        ? _c("div", { staticClass: "dcv-body" }, [
            _c(
              "div",
              { staticClass: "dcv-warning-strip" },
              [
                _c("fa", {
                  staticClass: "dcv-warning-icon",
                  attrs: { icon: ["fas", "exclamation-triangle"] },
                }),
                _vm._v(" "),
                _c("span", [_vm._v("This will mark the vehicle as inactive.")]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dcv-warning-strip" },
              [
                _c("fa", {
                  staticClass: "dcv-warning-icon",
                  attrs: { icon: ["fas", "exclamation-triangle"] },
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "This will automatically decommission any scanners associated with this vehicle."
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dcv-vehicle-card" }, [
              _c("div", { staticClass: "dcv-vehicle-row" }, [
                _c("span", { staticClass: "dcv-label" }, [_vm._v("Vehicle")]),
                _vm._v(" "),
                _c("span", { staticClass: "dcv-value" }, [
                  _vm._v(_vm._s(_vm.vehicle.vehicle_name)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dcv-vehicle-row" }, [
                _c("span", { staticClass: "dcv-label" }, [_vm._v("Region")]),
                _vm._v(" "),
                _c("span", { staticClass: "dcv-value" }, [
                  _vm._v(_vm._s(_vm.vehicle.region)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "dcv-confirm-text" }, [
              _vm._v("\n      Vehicle "),
              _c("b", { staticClass: "dcv-highlight" }, [
                _vm._v(_vm._s(_vm.vehicle.vehicle_name)),
              ]),
              _vm._v(" will be set to\n      "),
              _c("b", { staticClass: "dcv-highlight dcv-highlight--danger" }, [
                _vm._v("INACTIVE"),
              ]),
              _vm._v(
                ".\n      It can be re-commissioned later from the Inactive vehicles list.\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dcv-actions" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "dcv-confirm-btn",
                    on: {
                      click: function ($event) {
                        return _vm.submit()
                      },
                    },
                  },
                  [_vm._v("\n        Confirm Decommission\n      ")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }